// Service layer for the Blog & Newsletter editor.
// Currently mocked with timeouts. Replace the bodies with real API calls
// (WordPress REST: POST /wp-json/wp/v2/posts) when your backend is ready.

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const DEFAULT_CATEGORIES = [
  'Company News',
  'Industry Insights',
  'Client Stories',
  'Tutorials',
  'AI & CRM',
  'Product Updates',
];

// Starting values for a brand-new post: everything is empty so the user
// begins with a blank editor.
export const DEFAULT_POST = {
  title: '',
  contentType: 'blog', // 'blog' | 'newsletter'
  status: 'draft', // 'draft' | 'publish' | 'scheduled'
  categories: [],
  featuredImage: '',
  html: '',
};

/**
 * Publish (or schedule) a post to WordPress.
 * post: { title, html, contentType, status, categories, featuredImage }
 */
export async function publishPost(post) {
  // Real version, e.g.:
  // const res = await fetch(`${WP_URL}/wp-json/wp/v2/posts`, {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  //   body: JSON.stringify({ title: post.title, content: post.html, status: post.status }),
  // });
  // if (!res.ok) throw new Error('Publish failed');
  // return res.json();
  await delay(1800);
  return { success: true, id: Date.now(), post };
}

/** Save the post as a draft inside the CRM. */
export async function saveDraft(post) {
  await delay(400);
  return { success: true, id: Date.now(), post };
}

/** Generate an AI snippet (HTML string) for the given prompt. */
export async function generateAiContent(prompt) {
  await delay(1500);
  return `
    <div class="my-4 p-4 rounded-xl bg-blue-50 border border-blue-200">
      <div class="flex items-center gap-2 text-blue-600 font-semibold mb-1 text-sm">
        <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>
        AI Assistant Insight: "${prompt}"
      </div>
      <p class="text-slate-700 text-sm">
        Optimizing user experience across CRM touchpoints boosts conversion rates by up to 34%. Implementing multi-channel distribution ensures subscribers receive real-time updates as soon as blogs are live.
      </p>
    </div>
  `;
}